import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import { ListingData } from 'types/listingData'
import { BridgeProduct } from 'types/bridgeProduct'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import { ProductListingFetcher } from '@/components/organisms/productListing/productListingFetcher'
import BannersLayout, { BannersType } from './bannersLayout'
import ProductsContainerRedesign from '@/components/organisms/productsContainerRedesign'

type ManufacturerProductsContainerProps = {
  data: ListingData<BridgeProduct>
  description?: string
  showProductModal?: ShowProductModal
  productListingFetcher: ProductListingFetcher
  list: string
} & Rest

const ManufacturerProductsContainer: FC<ManufacturerProductsContainerProps> = ({
  data,
  description,
  showProductModal,
  productListingFetcher,
  list,
  ...rest
}) => (
  <Box
    textAlign="center"
    mb={50}
    flex="1"
    data-testid="productListingContainer"
    {...rest}
  >
    {data.banners && (
      <BannersLayout
        banners={data.banners}
        bannerDst={BannersType.Manufacturer}
        mb={{ desktop: description ? 20 : 50, tablet: 50, mobile: 20 }}
        gridColumnGap={16}
        gridRowGap={16}
        preload
        data-testid="bannersLayout"
      />
    )}
    <ProductsContainerRedesign
      fetcher={productListingFetcher}
      data={data}
      action={showProductModal}
      list={list}
      showPager={false}
      description={description}
    />
  </Box>
)

export default withProductDetailPopup(ManufacturerProductsContainer)
